export const ICON_SIZES = {
  X_SMALL: 16,
  SMALL: 20,
  MEDIUM: 24,
  LARGE: 40,
  X_LARGE: 48,
};